module.exports = __webpack_public_path__ + "media/images/rupes-nigra-skia-bd4904ddd0e6bb5ee2d0b5be91680f5d.png";